module.exports = __webpack_public_path__ + "img/ivf_final.b1572f0e.svg";